const StatusIcon = ({ status }) => (
    <>
        { status === "danger" && <i key="danger" className="fas fa-exclamation-circle text-danger"></i> }
        { status === "success" && <i key="success" className="fa fa-check text-success"></i> }
        { status === "warning" && <i key="warning" className="fas fa-exclamation-triangle text-warning"></i> }
    </>
)

export const ChecklistRow = ({ label, description, status, statusDetails, actions }) => (
    <div className="p-4 mb-3" style={ {
        borderRadius: "8px",
        border: "1px solid #d8e2ef",
        borderLeft: status === "warning" ? "6px solid #f5803e" : status === "danger" ? "6px solid #e63757" : "6px solid #00d27a",
    } }>
        <div className="d-flex align-items-center mb-2">
            <StatusIcon status={ status } />
            <p className="m-0 ml-2 font-weight-bold">{label}</p>
        </div>
        <div className="mb-2">
            <p className="m-0">{description}</p>
        </div>
        {
            (status === "warning" || status === "danger") &&
            <div>
                <div className="rounded px-2 py-3 mb-2" style={ {
                    backgroundColor: status === "danger" ? "#fce7eb" : "#fef0e8"
                } }>
                    <ul className="mb-0" style={ {
                        listStyle: "circle"
                    } }>
                        {
                            statusDetails
                                .filter(detailsLineItem => detailsLineItem !== null)
                                .map(
                                    (detailsLineItem, index) => <li key={ index } className={ `text-${ status } m-0 p-0` }>{ detailsLineItem }</li>
                                )
                        }
                    </ul>
                </div>

                <div className="d-flex flex-wrap">
                    {
                        actions
                            .map(
                                action => <a key={ action.url + action.label } target="_blank" href={ action.url } type="button" className="btn btn-primary mr-2 d-flex align-items-center justify-content-between rounded border py-2 mb-1">
                                    <p className="m-0 mr-2">{ action.label }</p>
                                    <i className="fas fa-external-link-alt"></i>
                                </a>
                            )
                    }


                </div>

            </div>
        }
    </div>
)